export default __webpack_public_path__ + "static/media/GANESHA INDISCHES RESTAURANT OUTER VIEW.a8c5658b.jpg";